<template>
    <div
        class="event-row-container"
        :class="{ 'is-locked': event.isLocked, 'is-highlighted': isHighlighted, 'is-expanded': isSelected }"
        :id="`event-${event.id}`"
    >
        <div
            @click="handleClick($event)"
            :class="{ 'is-expanded': isSelected }"
            class="event-row"
        >
            <div class="event-row__layout">
                <EventSummary
                    :isLive="event.isOngoing()"
                    :startDate="event.date"
                    :team1Name="event.team1Name"
                    :team2Name="event.team2Name"
                    :viewingOptions="{
                        liveBetting: event.isGoingToBeInLiveBetting,
                        liveSound: event.isGoingToHaveLiveAudio,
                        liveVideo: event.isGoingToHaveLiveVideo,
                        broadcast: broadcasts[event.betRadarId],
                    }"
                    :liveData="event.liveData"
                    :sportId="event.sportId"
                    :isInGrid="true"
                    :team1PreviousResult="event.team1PreviousResult"
                    :team2PreviousResult="event.team2PreviousResult"
                    :isCodeShown="isCodeShown"
                    :code="event.code"
                />
                <div class="event-row___markets">
                    <div class="primary-market__title">{{ primaryMarket && primaryMarket.name }}</div>
                    <div
                        class="primary-market__wrapper"
                        :class="event.isLocked ? 'is-locked' : ''"
                    >
                        <template v-if="event.oddCount > 0" >
                            <PrimaryMarket
                                v-if="!isSelected"
                                v-bind="primaryMarket || {}"
                                :marketFilters="marketFilters"
                                :eventId="event.id"
                                :selectedOdd="selectedOdd"
                                :isEventLocked="event.isLocked"
                                :oddValueDynamics="oddValueDynamics"
                                @oddClick="onOddClick"
                            />
                        </template>
                        <div class="primary-market__unavalibale" v-else>
                            {{ $t('no markets currently available') | upperCase }}
                        </div>
                        <button
                            v-if="displayMarketCount && !isSelected && additionalMarketCount"
                            :class="{ 'is-selected': hasSelectionInCollapsedMarkets }"
                            class="pick__more-odds"
                        >
                            {{ additionalMarketCount ? `+${additionalMarketCount}` : ''}}
                        </button>
                    </div>
                </div>
            </div>
            <div
                v-if="event.specialOfferId && !event.isOngoing()"
                class="event-row__special"
            >
                <i class="icon icon-special"/>
            </div>
            <div
                v-if="hasControls"
                class="event-row__controls"
            >
                <i
                    class="icon actionable"
                    :class="isPinned ? 'icon-pin_vertical_filled active': 'icon-pin_vertical'"
                    @click.stop="onPinClick(event.id)"
                />
            </div>
        </div>
        <div
            v-if="this.isSelected"
            class="event-row__markets-container"
        >
            <!--This is switcher for market filters (popular, all markets, etc.)-->
            <TypeSwitcher
                :types="marketFilters"
                :selected="trueSelectedMarketFilter"
                @valueChanged="onMarketClick"
                class="market-group__tabs"
            />
            <div>hello details sfhdjkfshfjk sdfjksdhfjdshf sdfhsfh h</div>
            <AllMarkets
                v-if="!areSpecialsVisible"
                :markets="markets"
                :isFavouritable="isFavouritable"
                :eventId="event.id"
                :isEventLocked="event.isLocked"
                :selectedOdd="selectedOdd"
                :isFavouriteMarket="isFavouriteMarket"
                :isOngoing="event.isOngoing()"
                :oddValueDynamics="oddValueDynamics"
                :areMarketsShownOutside="areMarketsShownOutside"
                @oddClick="onOddClick"
                @favouriteMarketClick="onFavouriteMarketClick"
                @marketHeightChange="emitHeightChange"
            />
            <SpecialMarkets
                v-if="areSpecialsVisible"
                :specialOfferId="event.specialOfferId || 0"
                :areMarketsShownOutside="areMarketsShownOutside"
            />
        </div>
        <MatchFooterRow
            v-if="event.matchFooter"
            :content="event.matchFooter"
        />
    </div>
</template>

<script>
    import { partition as _partition } from '@lodash';
    import EventSummary from '@modules/shared/event/EventSummary.vue';
    import { MarketFilter } from '@app/store/modules/ui/sportOffer/sports/enums.ts';
    import { MarketAttribute } from '@core/constants';
    import PrimaryMarket from './PrimaryMarket';
    import AllMarkets from './AllMarkets';
    import SpecialMarkets from './SpecialMarkets';
    import MatchFooterRow from './MatchFooterRow';
    import { capitalize } from '../../shared/filters';
    import { orderMarkets } from '../eventRowUtils';

    const ANIMATION_DURATION = 2000; // ms
    const SuperbetsMarketId = 999999;

    export default {
        name: 'EventRow',
        props: {
            event: {
                type: Object,
                required: true,
            },
            typeId: {
                type: [String, Number],
                required: true,
            },
            selectedMarketFilter: {
                type: String,
                default: '',
            },
            isFavouritable: {
                type: Boolean,
                required: true,
            },
            favouriteMarketIds: {
                type: Object,
                required: false,
                default() {
                    return {};
                }
            },
            isSelected: {
                type: Boolean,
                required: false,
            },
            isPinned: {
                type: Boolean,
                required: false,
                default: false,
            },
            hasSelectionInCollapsedMarkets: {
                type: Boolean,
                required: false,
                default: false,
            },
            selectedOdd: {
                type: String,
                required: false,
                default: '',
            },
            primaryMarketAttribute: {
                type: String,
                default: MarketAttribute.main,
            },
            isPinnable: {
                type: Boolean,
                default: true,
            },
            isHighlighted: {
                type: Boolean,
                required: false,
            },
            oddValueDynamics: {
                type: Object,
                required: false,
            },
            broadcasts: {
                type: Object,
                default: () => ({}),
            },
            displayMarketCount: {
                type: Boolean,
                default: true,
            },
            isCodeShown: {
                type: Boolean,
                required: false,
                default: false,
            },
            areMarketsShownOutside: {
                type: Boolean,
                required: true,
            }
        },
        mounted() {
            if (this.isSelected) {
                this.emitHeightChange();
            }
        },
        updated() {
            if (this.isSelected) {
                this.$nextTick(() => {
                    this.emitHeightChange();
                });
            }

            if (this.willExpand) {
                delete this.willExpand;
                this.$emit('expand');
            } else if (this.willCollapse) {
                delete this.willCollapse;
                this.$emit('collapse');
            }
        },
        watch: {
            isHighlighted(isHighlighted) {
                if (isHighlighted) {
                    if (this.timeout) {
                        clearTimeout();
                    }
                    this.timeout = setTimeout(() => {
                        this.$emit('removeHighlight');
                    }, ANIMATION_DURATION);
                }
            },
            isSelected(newValue) {
                if (newValue) {
                    this.willExpand = true;
                } else {
                    this.willCollapse = true;
                }
                this.emitRenderBeforeDestroy = true;
            },
        },
        computed: {
            trueSelectedMarketFilter() {
                const currentFilter = this.marketFilters.find(({ type }) => type === this.selectedMarketFilter)
                    || this.marketFilters[0];
                if (currentFilter.disabled) {
                    const firstAvailableFilter = this.marketFilters.find(({ disabled }) => !disabled);
                    return firstAvailableFilter ? firstAvailableFilter.type : null;
                }
                return currentFilter.type;
            },
            markets() {
                let markets = this.event.getMarkets();

                const [superbets, other] = _partition(markets, (m) => m.isSuperbet);
                if (superbets.length) {
                    const odds = superbets.map((s) => s.odds[0]);
                    const order = Math.min(...odds.map((odd) => odd.marketOrder));
                    const superbetsMarket = {
                        order,
                        odds,
                        id: SuperbetsMarketId,
                        uniqueId: SuperbetsMarketId,
                        name: this.$t('superbets'),
                        isSuperbet: true,
                        isLocked: false,
                    };
                    markets = [...other, superbetsMarket];
                }
                return orderMarkets(
                    markets,
                    this.primaryMarketAttribute,
                    [this.isFavouriteMarket, 'order'], ['desc', 'asc']
                );
            },
            areAdditionalMarketsLoaded() {
                return this.markets.length === this.event.marketCount
                    || this.markets.length > 1;
            },
            additionalMarketCount() {
                return Math.max(0, this.event.marketCount - 1);
            },
            primaryMarket() {
                return this.event.getPrematchMarket(this.primaryMarketAttribute);
            },
            hasControls() {
                return this.isPinnable;
            },
            areSpecialsVisible() {
                return this.trueSelectedMarketFilter === MarketFilter.specialOffer;
            },
            marketFilters() {
                const noMarkets = this.event.getOdds().length === 0;
                const markets = [
                    {
                        type: MarketFilter.allMarkets,
                        displayName: capitalize(this.$t('all markets')),
                        disabled: noMarkets,
                    },
                ];
                if (this.event.specialOfferId && !this.event.isOngoing()) {
                    markets.push({
                        type: MarketFilter.specialOffer,
                        displayName: capitalize(this.$t('special')),
                        icon: 'icon icon-special'
                    });
                }
                return markets;
            },
        },
        methods: {
            isFavouriteMarket(market) {
                return !!this.favouriteMarketIds[market.id];
            },
            /* this logic is used to avoid using stopPropagation on click because of reasons explained here
                https://css-tricks.com/dangers-stopping-event-propagation/
            */
            handleClick(nativeEvent) {
                const target = nativeEvent.target;
                let clickedOnEvent = false;
                if (target === this.$el) {
                    clickedOnEvent = true;
                } else {
                    /*
                        class 'actionable' is a convention to put on html elements with their own click handlers.
                        These elements shouldn't activate their parent click handler
                    */
                    clickedOnEvent = target.className.indexOf('actionable') === -1;
                }
                if (clickedOnEvent) {
                    const offsetTop = this.$el.getBoundingClientRect().y;

                    this.$emit('eventClick', {
                        offsetTop,
                        eventId: this.event.id,
                        typeId: this.typeId,
                    });
                }
            },
            onMarketClick(type) {
                const offsetTop = this.$el.getBoundingClientRect().y;
                this.$emit('marketClick', type, {
                    offsetTop,
                });
            },
            onFavouriteMarketClick(marketId) {
                this.$emit('favouriteMarketClick', marketId);
            },
            onOddClick(odd) {
                if (this.event.isLocked || odd.isLocked) {
                    return;
                }

                this.$emit('oddClick', this.event.id, odd);
            },
            onPinClick(eventId) {
                this.$emit('pinClick', eventId);
            },
            getMarketStickyScrollDistance() {
                const marketsStickyHeader = this.$el.querySelector('.market-group__tabs');
                const marketsContainer = this.$el.querySelector('.event-row__markets-container');
                if (!marketsStickyHeader || !marketsContainer) {
                    return 0;
                }
                const verticalOffset = marketsContainer.getBoundingClientRect().y
                    - marketsStickyHeader.getBoundingClientRect().y;
                return verticalOffset;
            },
            emitHeightChange() {
                this.$emit('rowHeightChanged', this.$el.clientHeight);
            }
        },
        beforeDestroy() {
            if (this.timeout) {
                clearTimeout(this.timeout);
            }
            /*  (1) page height changes can make the row be destroyed because it's situated
                in a virtual scroller. We have to notify the parent that the render
                of this row is finished so he can initiate the scroll
                (We notify the parent that this row is finished rendering in 2 cases.
                The first one is when it expanded after it gets full markets.
                If this row is destroyed due to falling out of the rendered area of
                the virtual scroll the update after getting full markets is never called
                so we have to notify the parent that it's indeed finished rendering (or being destoyed))
            */
            if (this.emitRenderBeforeDestroy) {
                if (this.isSelected) {
                    this.$emit('expand');
                } else {
                    this.$emit('collapse');
                }
            }
        },
        components: {
            EventSummary,
            PrimaryMarket,
            AllMarkets,
            SpecialMarkets,
            MatchFooterRow,
        },
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/eventGrid/components/EventRow.vue